export enum ProductSpecs {
  Carpet = 'CARPET',
  Cushion = 'Cushion',
  Fabric = 'FABRIC',
  Sample = 'SAMPLE',
  Yarn = 'YARN',
}
